import ajaxService from "./ajax-service";
import { validationErrors } from "../utils";

class VehicleService {

  // async getVehicles(page, search) {
  //   const pageParam = `page=${page}`
  //   let params = search ? pageParam + `&search=${search}` : pageParam;
  //   const response = await ajaxService.get(`/vehicles?${params}`);
  //   if (response?.success ?? false) {
  //     return response;
  //   } else {
  //     const errors = response.data.errors;
  //     return validationErrors(errors);
  //   }
  // }
  async getVehicles(page = 1, search = "", advanced_filters = {}) {
    let params = new URLSearchParams();

    params.append("page", page);

    if (search) {
      params.append("search", search);
    }

    Object.entries(advanced_filters).forEach(([key, value]) => {
      if (value) {
        params.append(`advanced_filters[${key}]`, value);
      }
    });

    const response = await ajaxService.get(`/vehicles?${params.toString()}`);

    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response?.data?.errors;
      return validationErrors(errors);
    }
  }

  async view(id) {
    const response = await ajaxService.get(`/vehicles/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async getLatestID() {
    const response = await ajaxService.get(`/vehicles-latest-id`);
    if (response.success) {
      return response;
    }
  }

  async getColumns() {
    const response = await ajaxService.get("/vehicles-columns");
    if (response.success) {
      return response;
    }
  }

  async getTypes() {
    const response = await ajaxService.get("/vehicles-types");
    if (response.success) {
      return response;
    }
  }

  async download(data) {
    const response = await ajaxService.post("/vehicles-export", data);
    if (response.success) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async addVehicle(data) {
    const response = await ajaxService.post(`/vehicles`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async deleteVehicle(id) {
    const response = await ajaxService.delete("/vehicles/", id);
    if (response.success) {
      return response;
    }
  }

  async updateVehicle(id, data) {
    const response = await ajaxService.put("/vehicles/", id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async globalSearch(data) {
    const response = await ajaxService.post(`/global-search`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors
      return validationErrors(errors)
    }
  }

}
const vehicleService = new VehicleService();

export default vehicleService;
